import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import "./scss/common-tab.scss";

interface IProps {
  onChange: (code: string) => void;
  Cwidth?: number;
  active: string;
  list: Array<any>;
}
interface IState {}

const CommonTab = (props: IProps, state: IState) => {
  const { onChange, Cwidth, active, list } = props;
  useEffect(() => {
    return () => {};
  }, []);
  const action = (code: string) => {
    onChange(code);
  };
  return (
    <section style={{ display: "flex", justifyContent: "center" }}>
      <section className="common-tab-warp">
        {list?.map((item: any) => (
          <p
            aria-hidden="true"
            key={item.code}
            style={{ width: `${Cwidth}px` }}
            className={item.code === active ? "tab-item-active" : "tab-item"}
            onClick={() => action(item.code)}
          >
            {item.value}
          </p>
        ))}
      </section>
    </section>
  );
};

export default observer(CommonTab);
